import { searchableUtilityProgramsCollection } from '@/reducers/utilityPrograms'
import { SuggestionCardProps } from '../DeviceSuggestionCard'
import { useDataAndSetLoadedState } from '../../hooks/useDataAndSetLoadedState'

export type Props = SuggestionCardProps & {
  programId: number
}

export function useLoadData(props: Props) {
  const { data: utilityPrograms, isLoadingOrIdle } =
    searchableUtilityProgramsCollection.useFetch({
      path: `utility_programs/${props.programId}`,
    })
  const program = utilityPrograms.length ? utilityPrograms[0] : undefined

  return {
    data: {
      program,
    },
    isLoadingOrIdle,
  }
}

export default function useViewModel(props: Props) {
  const { setLoadedSignal, articles } = props
  const {
    data: { program },
    isLoadingOrIdle,
  } = useDataAndSetLoadedState({
    useLoader: useLoadData,
    props,
    setLoadedSignal: setLoadedSignal,
  })

  return {
    displayName: program?.name ?? '',
    isLoadingOrIdle,
    articles,
  }
}
